import {
  loadDataSink,
  loadMyDataSinks,
  setContextualSupport,
  unsetContextualSupport,
} from 'js/actions';
import { GET_SINKS_REQUEST, GET_SINK_REQUEST } from 'js/constants/actionTypes';
import * as OLD_PATHS from 'js/constants/pathnames';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { SearchFilterViews } from 'js/constants/visibilityFilters';
import { getConnectionOrVendorType } from 'js/lib/ResourceUtils';
import UIUtils from 'js/lib/UIUtils';
import { getEligibleSinkEntities } from 'js/reducers/selectors';
import has from 'lodash/has';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { ModalFilePreview } from 'new/elements/ModalFilePreview';
import { ModalReingest } from 'new/elements/ModalReingest';
import { connect } from 'react-redux';
import ViewDataSinks from './ViewDataSinks';

const mapStateToProps = (state, ownProps) => {
  const {
    paging,
    app: {
      listing: { aclQueryMode, selectedCardId },
      visibilityFilters: { filters },
    },
    sinks: { byId },
    request,
  } = state;
  const sinkId = UIUtils.extractParamFromURL(ownProps.match);
  const sinks = getEligibleSinkEntities(state);

  const getSourceMeta = (sinkId) => {
    const {
      entities: { sinks, vendors },
      paging: { metaInfoById },
    } = state;

    const sinkEntity = sinks[sinkId];
    let connectionOrVendorType = getConnectionOrVendorType(
      sinkEntity,
      vendors,
      'sink_type',
      'vendor_id',
    );
    return connectionOrVendorType && has(metaInfoById, connectionOrVendorType)
      ? metaInfoById[connectionOrVendorType]
      : null;
  };

  return {
    sinkId,
    sinks,
    allSinks: byId,
    paging,
    aclQueryMode,
    filters: filters[SearchFilterViews.DATA_SINKS],
    // we'll only show loading if not showing detail view
    isLoading: (request[GET_SINK_REQUEST] && !selectedCardId) || request[GET_SINKS_REQUEST],
    getSourceMeta,
  };
};

const AsyncViewDataSinksContainer = connect(mapStateToProps, {
  loadMyDataSinks,
  loadDataSink,
  setContextualSupport,
  unsetContextualSupport,
})(ViewDataSinks);

export const viewDataSinksContainerScreenConfig = {
  screenName: 'Destinations',
  domain: 'integrate',
  exact: true,
  path: [`${ROUTE_REDESIGN}${ROUTE_CONNECT}${OLD_PATHS.ROUTE_DESTINATIONS}`],
  modals: [ModalFilePreview, ModalReingest],
  defaultProps: {
    onlyTableView: true,
  },
};

AsyncViewDataSinksContainer.screenConfig = viewDataSinksContainerScreenConfig;

export default AsyncViewDataSinksContainer;
